
export default class SFX {
  private static _spoopy: HTMLAudioElement | null = null;

  public static get Spoopy(): HTMLAudioElement {
    if (!SFX._spoopy) {
      SFX._spoopy = document.getElementById('sfx_spoopy') as HTMLAudioElement;
      if (!SFX._spoopy) {
        throw new Error('Failed to find sfx_spoopy sound effect!');
      }
    }
    return SFX._spoopy;
  }

  private constructor() {
    // Not used, this is a utility class
  }
}
